import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import BaseAPI from '../../api/apiurl';

const ApexChatSTicket = () => {
  const [options, setOptions] = useState({
    series: [],
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: '13px',
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    xaxis: {
      categories: ["priority-0", "Priority-01", "Priority-02", "Priority-03", "Priority-04", "Priority-05"],
      labels: {
        formatter: function (val) {
          return val;
        },
      },
    },
    yaxis: {
      title: {
        text: undefined,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40,
    },
  });

  useEffect(() => {
    const company_id = localStorage.getItem('companyid');
    const customer_id = localStorage.getItem('customerid');
    fetch(`${BaseAPI}monthlyservice?company_id=${company_id}&customer_id=${customer_id}`)
      .then(response => response.json())
      .then(data => {
        const transformedData = Object.keys(data.data[0])
          .filter(key => key !== 'priority' && key !== 'status')
          .map(key => ({
            name: key.charAt(0).toUpperCase() + key.slice(1),
            data: data.data.map(item => parseInt(item[key])),
          }));

        setOptions(prevOptions => ({
          ...prevOptions,
          series: transformedData,
          xaxis: {
            categories: data.data.map(item => `priority-${item.priority}`),
            labels: {
              formatter: function (val) {
                return val;
              },
            },
          },
        }));
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  return <Chart options={options} series={options.series} type="bar" height={350} />;
};

export default ApexChatSTicket;
    